export default {
  reportBuilder: 'Tvorba reportov',
  subheadline: 'Tieto nastavenia definujú globálny vzhľad PDF súborov generovaných systémom Qmulus.',
  reportForm: {
    size: {
      label: 'Predvolená veľkosť papiera',
      tooltip: 'Určuje veľkosť papiera, ktorá je vždy predvolene vybraná.',
    },
    language: {
      label: 'Jazyk',
      tooltip: 'Výber jazyka určuje, ako sa v reporte zobrazujú časové pečiatky a ďalšie lokalizované časti textu.',
    },
    logo: {
      label: 'Logo',
      tooltip: 'Vybrané logo sa zobrazuje v hlavičke každého reportu.',
    },
    header: {
      height: {
        tooltip: 'Určuje výšku hlavičky používanú na každej strane reportu.',
      },
      contentLeft: {
        tooltip: 'Určuje ľavý text hlavičky zobrazený na každej strane reportu.',
      },
      contentCenter: {
        tooltip: 'Určuje stredový text hlavičky zobrazený na každej strane reportu.',
      },
      contentRight: {
        tooltip: 'Určuje pravý text hlavičky zobrazený na každej strane reportu.',
      },
    },
    footer: {
      contentLeft: {
        tooltip: 'Určuje ľavý text päty zobrazený na každej strane reportu.',
      },
      contentCenter: {
        tooltip: 'Určuje stredový text päty zobrazený na každej strane reportu.',
      },
      contentRight: {
        tooltip: 'Určuje pravý text päty zobrazený na každej strane reportu.',
      },
    },
  },
  errors: {
    unsupportedFileType: 'Aktuálne logo je v nepodporovanom formáte súboru. Nahrajte nové logo.',
    logoLoadingFailure: 'Aktuálne logo sa nepodarilo načítať. Odporúčame nahrať nové logo.',
  },
};
